// *****************************************************************************************************
// Original code from https://www.youtube.com/watch?v=o1yMqPyYeAo but altered to meet requirements.
// *****************************************************************************************************

import Component from './Component';

export default class ProductCalendar extends Component {

  load() {
    this.initProductCalendar();
    // console.log('ProductCalendar.');

    super.load();
  }

  initProductCalendar() {
    const dateSessions =  window.Sessions;
    if(!dateSessions || dateSessions.length === 0) return;

		this.date = new Date(dateSessions[0].StartDate);

    document.querySelector(".product-calendar__prev").addEventListener("click", () => {
      this.date.setMonth(this.date.getMonth() - 1);
      this.renderCalendar(dateSessions);
    });

    document.querySelector(".product-calendar__next").addEventListener("click", () => {
      this.date.setMonth(this.date.getMonth() + 1);
      this.renderCalendar(dateSessions);
    });

    this.renderCalendar(dateSessions);
  }

  /***************************************************************
   * Render Calendar
   ***************************************************************/

  renderCalendar(dateSessions) {
    let date = this.date;

    date.setDate(1);

    const monthDays = document.querySelector(".product-calendar__days");

    const lastDay = new Date(
      date.getFullYear(),
      date.getMonth() + 1,
      0
    ).getDate();

    const prevLastDay = new Date(
      date.getFullYear(),
      date.getMonth(),
      0
    ).getDate();

    // Get first day of the week (Sun = 0, Mon = 1 etc.) for month then convert it to Mon = 0
    let firstDayIndex = date.getDay();
    firstDayIndex = firstDayIndex === 0 ? 6 : firstDayIndex - 1;

    const lastDayIndex = new Date(
      date.getFullYear(),
      date.getMonth() + 1,
      0
    ).getDay();

    // Get day of the week (Sun = 0, Mon = 1 etc.) then convert it to Monday = 0
    const nextDays = lastDayIndex === 0 ? 0 : 7 - lastDayIndex;

    const months = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];

    document.querySelector(".product-calendar__date h3").innerHTML = `${months[date.getMonth()]} ${date.getFullYear()}`;

    // Group all dates used by sessions
    let datesGrouped = [];
    dateSessions.forEach(el => {
      const dateOnly = el.StartDate.split('T')[0];
      if(!datesGrouped.includes(dateOnly)) {
        datesGrouped.push(dateOnly)
      }
    });

    let days = "";
    let cycleDate = new Date(date.getFullYear(), date.getMonth() - 1, 1);
    for (let x = firstDayIndex; x > 0; x--) {
      const day = prevLastDay - x + 1;
      cycleDate.setDate(day);
      days += this.addDaysForCalendar(day, cycleDate, datesGrouped, "product-calendar__prev-date");
    }

    cycleDate = new Date(date.getFullYear(), date.getMonth(), 1);
    for (let i = 1; i <= lastDay; i++) {
      cycleDate.setDate(i);
      days += this.addDaysForCalendar(i, cycleDate, datesGrouped, "");
    }

    cycleDate = new Date(date.getFullYear(), date.getMonth() + 1, 1);
    for (let j = 1; j <= nextDays; j++) {
      cycleDate.setDate(j);
      days += this.addDaysForCalendar(j, cycleDate, datesGrouped, "product-calendar__next-date");
    }

    monthDays.innerHTML = days;

    const highlightedDates = document.getElementsByClassName('product-calendar__highlight');

    if(highlightedDates) {
      // Add event listeners to highlighted calendar dates
      const hilightedArray = Array.from(highlightedDates);
      hilightedArray.forEach((el) => {
        if(el === hilightedArray[0]) {
          el.classList.add('product-calendar__highlight--select');
        }

        el.addEventListener('click', () => {
          this.renderSessionTimes(el, dateSessions);
          hilightedArray.forEach((hi) => {
            hi.classList.remove('product-calendar__highlight--select');
          });
          el.classList.add('product-calendar__highlight--select');
        });
      });

      // Render sessions from first hilighted date
      this.renderSessionTimes(highlightedDates[0], dateSessions);
    }
  };

  addDaysForCalendar(day, cycleDate, datesGrouped, unhighlightedClass) {
    const fullDate = this.getFullDate(cycleDate);
    const dateHasSession = this.doesDateHaveASession(cycleDate, datesGrouped);
    const classEl = dateHasSession ? "product-calendar__highlight" : unhighlightedClass;
    const tabindex = dateHasSession ? "0" : "-1";

    return `<div class="${classEl}" data-date="${fullDate}" tabindex="${tabindex}" aria-label="${fullDate}">${day}</div>`;
  }

  doesDateHaveASession(date, datesGrouped) {
    const strDate = this.convertDateToString(date);
    return datesGrouped.includes(strDate);
  }


  getFullDate(date) {
    return [date.getFullYear(), this.pad(date.getMonth()+1), this.pad(date.getDate())].join('-');
  }

  pad(num) {
    return ("00" + num).slice(-2);
  }

  convertDateToString(date) {
    const mm = date.getMonth() + 1; // getMonth() is zero-based
    const dd = date.getDate();

    return `${date.getFullYear()}-${(mm>9 ? '' : '0') + mm}-${(dd>9 ? '' : '0') + dd}`;
  };

  /***************************************************************
   * Sessions
   ***************************************************************/

  renderSessionTimes(el, dateSessions) {
		const elDate = el.getAttribute('data-date');
		let dates = [];
		dateSessions.forEach((date) => {
			if(date.StartDate.split('T')[0] === elDate) {
				dates.push(date)
			}
		});

		return this.getSessionTimes(dates);
	}

  getSessionTimes(dates) {
    const sessionsEl = document.getElementsByClassName('product-calendar__sessions')[0];
    const productDetail = document.getElementById('contactAddress');
    let elements = '<h4>EVENT SESSIONS</h4>';

    // Create eventDetail and add data attributes to 'Other'
    let eventDetails = {
      title: productDetail.getAttribute('productname'),
      location: productDetail.children[0].innerHTML,
      details: sessionsEl.getAttribute('data-summary'),
      sprop: null
    };

    dates.forEach((date) => {
      let eventDateTime = '';
      const startTime = this.getTimeFromDate(date.StartDate);
      const endTime = this.getTimeFromDate(date.EndDate);

      if(startTime === '12:00am' && endTime === '12:00am') {
        const dateStart = new Date(date.StartDate.split('T')[0]);
        eventDateTime = `${this.pad(dateStart.getDate())}/${this.pad(dateStart.getMonth()+1)}/${dateStart.getFullYear()} (All day)`;
      } else {
        eventDateTime = `${startTime} - ${endTime}`;
      }

      eventDetails.start = date.StartDate;
      eventDetails.end = date.EndDate;
      // <a href="#" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" aria-label="Add to calendar"><span class="product-calendar__dd-plus">+</span> Calendar</a>
      let exportLinkHtml = '<a href="#" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" aria-label="Add to calendar"><span class="product-calendar__dd-plus"></span></a>';
      let menu = `<div class="dropdown-menu dropdown-menu-right">`
      menu += `<a class="dropdown-item" href="${this.getGoogleCalUrl(eventDetails)}" target="_blank">Google Calendar</a>`;
      menu += `<a class="dropdown-item dropdown-item--other" href="#" data-title="${this.decode(eventDetails.title)}" data-details="${this.decode(eventDetails.details)}" data-location="${this.decode(eventDetails.location)}" data-start="${this.decode(eventDetails.start)}" data-end="${this.decode(eventDetails.end)}">Other</a>`;
      elements += `<div class="product-calendar__session">${eventDateTime} ${exportLinkHtml}${menu}</div>`;
		});

    sessionsEl.innerHTML = elements;

    const otherEls = document.getElementsByClassName('dropdown-item--other');
    Array.from(otherEls).forEach((oel) => oel.addEventListener('click', (el) => {
      const target = el.target;
      eventDetails.title = target.dataset.title;
      eventDetails.details = target.dataset.details;
      eventDetails.location = target.dataset.location;
      eventDetails.start = target.dataset.start;
      eventDetails.end = target.dataset.end;
      this.createIcs(eventDetails);
    }));
  }

  decode(str) {
    return decodeURIComponent((str + '').replace(/\+/g, '%20'));
  }

  getTimeFromDate(date) {
    const time = date.split('T');
    if(!time) return '';

    return this.tConvert(time[1].substring(0,5));
  }

  tConvert(time) {
    // Check correct time format and split into components
    time = time.toString().match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];

    if (time.length > 1) { // If time format correct
      time = time.slice(1); // Remove full string match value
      time[5] = +time[0] < 12 ? 'am' : 'pm'; // Set AM/PM
      time[0] = +time[0] % 12 || 12; // Adjust hours
    }
    return time.join(''); // return adjusted time or original string
  }

  getGoogleCalUrl (eventDetails) {
    eventDetails = this.sanitizeEventDetails(eventDetails);

    return "http://www.google.com/calendar/event?action=TEMPLATE&trp=false" +
    "&text=" + eventDetails.title +
    "&dates=" + eventDetails.start.replace(/[:-]/g,'') +
    "/" + eventDetails.end.replace(/[:-]/g,'') +
    "&location=" + eventDetails.location +
    "&details=" + eventDetails.details +
    "&sprop=" + eventDetails.url;
  }

  sanitizeEventDetails ( eventDetails ) {
    eventDetails.title = ( eventDetails.title ? encodeURIComponent( eventDetails.title ) : '' );
    eventDetails.start = ( typeof eventDetails.start.toRFC3339UTCString == 'function' ?
      eventDetails.start.toRFC3339UTCString(true,true) : eventDetails.start );
    eventDetails.end = ( typeof  eventDetails.end.toRFC3339UTCString == 'function' ?
      eventDetails.end.toRFC3339UTCString(true,true) : eventDetails.end );
    eventDetails.location = ( eventDetails.location ? encodeURIComponent( eventDetails.location ) : '' );
    eventDetails.details = ( eventDetails.details ? encodeURIComponent( eventDetails.details ) : '' );

    // avoid 414 error due to overlong url
    var MAX_DETAILS_LENGTH = 1550;
    if (eventDetails.details.length > MAX_DETAILS_LENGTH) {
      eventDetails.details = eventDetails.details.substr(0, MAX_DETAILS_LENGTH);
      eventDetails.details.replace(/%[^0-9]*$/, "");
      eventDetails.details += "...";
    }
    eventDetails.url = ( eventDetails.url ? encodeURIComponent( eventDetails.url ) : '' );
    return eventDetails;
  }

  createIcs (eventDetails) {
    var calEvent = this.getIcsContent(eventDetails.title, eventDetails.details, eventDetails.location, eventDetails.start, eventDetails.end);

    this.download("event.ics", calEvent);
  }

  getIcsContent (subject, description, location, begin, stop) {
    // I'm not in the mood to make these optional... So they are all required
    if (typeof subject === 'undefined' ||
        typeof description === 'undefined' ||
        typeof location === 'undefined' ||
        typeof begin === 'undefined' ||
        typeof stop === 'undefined'
    ) {
        return false;
    }

    const SEPARATOR = '\r\n';
    const start_date = new Date(begin);
    const end_date = new Date(stop);

    const start_year = start_date.getFullYear().toString();
    const start_month = this.pad((start_date.getMonth() + 1).toString());
    const start_day = this.pad((start_date.getDate()).toString());
    const start_hours = this.pad(start_date.getHours().toString());
    const start_minutes = this.pad(start_date.getMinutes().toString());
    const start_seconds = "00";

    const end_year = end_date.getFullYear().toString();
    const end_month = this.pad((end_date.getMonth() + 1).toString());
    const end_day = this.pad((end_date.getDate()).toString());
    const end_hours = this.pad(end_date.getHours().toString());
    const end_minutes = this.pad(end_date.getMinutes().toString());
    const end_seconds = "00";

    // Since some calendars don't add 0 second events, we need to remove time if there is none...
    let start_time = '';
    let end_time = '';
    let allDay = false;

    if (start_hours + start_minutes + end_hours + end_minutes !== '00000000') {
      start_time = 'T' + start_hours + start_minutes + start_seconds;
      end_time = 'T' + end_hours + end_minutes + end_seconds;
    } else {
      allDay = true;
    }

    const start = start_year + start_month + start_day + start_time;
    const end = end_year + end_month + end_day + end_time;

    const calendarEvent = [
        'BEGIN:VEVENT',
        'CLASS:PUBLIC',
        'DESCRIPTION:' + description,
        'DTSTART;VALUE=DATE:' + start,
        allDay ? '' : 'DTEND;VALUE=DATE:' + end,
        'LOCATION:' + location,
        'SUMMARY;LANGUAGE=en-us:' + subject,
        'TRANSP:TRANSPARENT',
        'END:VEVENT'
    ].join(SEPARATOR);

    return calendarEvent;
  }

  download (filename, content) {
    const SEPARATOR = (navigator.appVersion.indexOf('Win') !== -1) ? '\r\n' : '\n';
    const calendarStart = [
        'BEGIN:VCALENDAR',
        'VERSION:2.0'
    ].join(SEPARATOR);
    const calendarEnd = SEPARATOR + 'END:VCALENDAR';

    filename = (typeof filename !== 'undefined') ? filename : 'calendar';
    const calendar = calendarStart + SEPARATOR + content + calendarEnd;

    //NB: Removed escape()
    window.open( "data:text/calendar;charset=utf8," + calendar);
  }

}
